exports.list = {
    path: '/supplier',
    name: 'supplier_list', 
      meta: {
        authRequired: true,
      },
    component: () => import("@/views/main/supplier/List.vue"),
}
exports.show = {
    path: '/supplier/show/:id',
    name: 'supplier_show', 
        meta: {
            authRequired: true,
        },
    component: () => import("@/views/main/supplier/Show.vue"),
}